import React from 'react';
import Header from '../../components/Header/Header';
import Banner from '../../components/Banner/Banner';
import AboutSection from '../../components/AboutSection/AboutSection';
import FishingSection, { FishingSectionReversed, FishingSectionThird } from '../../components/FishingSection/FishingSection';
import ExploreModels from '../../components/ExploreModels/ExploreModels';
import ContactForm from '../../components/ContactForm/ContactForm';
import Footer from '../../components/Footer/Footer';

function ExploreActivities() {
  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <Banner hideContent />
        <AboutSection />
        <FishingSection />
        <FishingSectionReversed />
        <FishingSectionThird />
        <ExploreModels />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}

export default ExploreActivities;
